import React, { Component } from 'react'
import SystemLabelMasterCollection from './../../collections/system_label_master_collection'

class SelectKudouhoushiki extends Component {

  handleChange = (e) => {
    this.props.actions.changeSelectKudouhoushiki({
      selectKudouhoushiki: e.target.value,
    })
  }

  render() {
    const { payload } = this.props.systemLabelMastersApi
    if (!payload) {
      return null
    }
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    const { selectKudouhoushiki } = this.props
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.KUDOUHOUSHIKI}</h3>
        <p className='selectWrap searchArea__item__inner'>
          <select
            className="select"
            value={selectKudouhoushiki}
            onChange={this.handleChange}
          >
            <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.ALL}</option>
            {
              systemLabelMasterCollection.getValueList('item', 'kudouhoushiki').map(i => {
                return <option key={i.get('label_key')} value={i.get('label_key')}>{i.getValueI18n()}</option>
              })
            }
          </select>
        </p>
      </div>
    )
  }
}

export default SelectKudouhoushiki
